import { useState } from "react";
import axios from "axios";
import LoaderIcon from "../../utils/loader";
import SuccessModal from "../../utils/successModalMsg";
import Button from "../common/Button";

const ContactForm = () => {
  // Form
  const [loading, setLoading] = useState(false);
  const [formError, setFormError] = useState([]);
  const [formData, setFormData] = useState({
    full_name: "",
    subject: "",
    email: "",
    phone_number: "",
    message: "",
  });

  const { full_name, subject, email, phone_number, message } = formData;

  const onChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const onSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    // declare the data fetching function
    const PostFormData = async () => {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      };

      const body = JSON.stringify({
        full_name,
        subject,
        email,
        phone_number,
        message,
      });

      try {
        const res = await axios.post(
          `${process.env.REACT_APP_API_URL}/contact-us`,
          body,
          config,
        );
        setLoading(false);
        if (res.status === 201) {
          handleShow();
          setFormData({
            full_name: "",
            subject: "",
            email: "",
            phone_number: "",
            message: "",
          });
        }
      } catch (err) {
        setFormError(err.response.data);
      } finally {
        setLoading(false);
      }
    };
    PostFormData();
  };

  //Modal
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <div
      className="cht-relative cht-bg-[#1e293b] cht-py-16 sm:cht-py-20 cht-overflow-hidden !cht-font-body"
      id="contact-form"
    >
      {/* Decorative Blur Spheres */}
      <div className="cht-absolute cht-top-0 cht-left-1/4 cht-w-96 cht-h-96 cht-bg-blue-500/10 cht-rounded-full cht-blur-3xl cht-pointer-events-none" />
      <div className="cht-absolute cht-bottom-0 cht-right-1/4 cht-w-96 cht-h-96 cht-bg-indigo-500/10 cht-rounded-full cht-blur-3xl cht-pointer-events-none" />

      <div className="cht-max-w-7xl cht-mx-auto cht-px-4 sm:cht-px-6 lg:cht-px-8 cht-relative cht-z-10">
        <div className="cht-grid lg:cht-grid-cols-12 cht-gap-10 lg:cht-gap-12 cht-items-center">
          {/* Left Intro Column (5 cols) */}
          <div className="lg:cht-col-span-5 cht-space-y-5 cht-text-left">
            <div className="cht-inline-flex cht-items-center cht-gap-2 cht-px-3.5 cht-py-1.5 cht-bg-white/10 cht-backdrop-blur-md cht-border cht-border-white/15 cht-rounded-full cht-text-xs !cht-font-bold cht-text-white">
              <span>Direct Inquiries</span>
            </div>

            <h2 className="!cht-font-heading cht-text-2xl sm:cht-text-4xl lg:cht-text-5xl !cht-font-extrabold cht-text-white cht-tracking-tight !cht-leading-[1.18]">
              Have a Project in Mind?
            </h2>

            <p className="!cht-font-body cht-text-sm sm:cht-text-base cht-text-slate-300 cht-leading-relaxed">
              We would love to hear from you. Whether you want to explore an
              enterprise software scope, need a technical consultation, or have
              an inquiry, our engineering leads are ready to collaborate.
            </p>

            <div className="cht-pt-4 cht-border-t cht-border-white/10 cht-space-y-3">
              <div className="cht-flex cht-items-center cht-gap-3 cht-text-xs sm:cht-text-sm cht-text-slate-300">
                <span className="cht-font-bold cht-text-white">Email:</span>
                <a
                  href="mailto:info@codehubtech.org"
                  className="cht-text-blue-300 hover:cht-text-blue-200 cht-transition-colors cht-no-underline"
                >
                  info@codehubtech.org
                </a>
              </div>
              <div className="cht-flex cht-items-center cht-gap-3 cht-text-xs sm:cht-text-sm cht-text-slate-300">
                <span className="cht-font-bold cht-text-white">
                  Phone / WhatsApp:
                </span>
                <a
                  href="https://wa.me/2349072444299"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="cht-text-blue-300 hover:cht-text-blue-200 cht-transition-colors cht-no-underline"
                >
                  +234 907 244 4299
                </a>
              </div>
            </div>
          </div>

          {/* Right Form Column (7 cols) */}
          <div className="lg:cht-col-span-7">
            <div className="cht-rounded-[24px] cht-border cht-border-white/15 cht-bg-white/[0.06] cht-backdrop-blur-xl cht-p-6 sm:cht-p-8 md:cht-p-10 cht-shadow-2xl">
              <form
                className="cht-space-y-4 sm:cht-space-y-5"
                onSubmit={(e) => onSubmit(e)}
              >
                <div className="cht-grid sm:cht-grid-cols-2 cht-gap-4">
                  <div>
                    <label
                      className="cht-block cht-text-xs !cht-font-bold cht-text-slate-300 cht-mb-1.5"
                      htmlFor="full_name"
                    >
                      Full Name *
                    </label>
                    <input
                      type="text"
                      className="cht-w-full cht-bg-white/10 cht-border cht-border-white/20 focus:cht-border-[#3e57da] focus:cht-bg-white/15 cht-rounded-xl cht-px-4 cht-py-3 cht-text-sm cht-text-white cht-placeholder-slate-400 focus:cht-ring-2 focus:cht-ring-[#3e57da]/50 cht-outline-none cht-transition-all"
                      id="full_name"
                      placeholder="e.g. Alexander Vance"
                      name="full_name"
                      onChange={(e) => onChange(e)}
                      value={full_name}
                      required
                    />
                  </div>

                  <div>
                    <label
                      className="cht-block cht-text-xs !cht-font-bold cht-text-slate-300 cht-mb-1.5"
                      htmlFor="phone_number"
                    >
                      Phone Number *
                    </label>
                    <input
                      type="text"
                      className="cht-w-full cht-bg-white/10 cht-border cht-border-white/20 focus:cht-border-[#3e57da] focus:cht-bg-white/15 cht-rounded-xl cht-px-4 cht-py-3 cht-text-sm cht-text-white cht-placeholder-slate-400 focus:cht-ring-2 focus:cht-ring-[#3e57da]/50 cht-outline-none cht-transition-all"
                      id="phone_number"
                      placeholder="+234 ..."
                      name="phone_number"
                      onChange={(e) => onChange(e)}
                      value={phone_number}
                      required
                    />
                  </div>
                </div>

                <div className="cht-grid sm:cht-grid-cols-2 cht-gap-4">
                  <div>
                    <label
                      className="cht-block cht-text-xs !cht-font-bold cht-text-slate-300 cht-mb-1.5"
                      htmlFor="email"
                    >
                      Email Address *
                    </label>
                    <input
                      type="email"
                      className="cht-w-full cht-bg-white/10 cht-border cht-border-white/20 focus:cht-border-[#3e57da] focus:cht-bg-white/15 cht-rounded-xl cht-px-4 cht-py-3 cht-text-sm cht-text-white cht-placeholder-slate-400 focus:cht-ring-2 focus:cht-ring-[#3e57da]/50 cht-outline-none cht-transition-all"
                      id="email"
                      placeholder="name@company.com"
                      name="email"
                      onChange={(e) => onChange(e)}
                      value={email}
                      required
                    />
                  </div>

                  <div>
                    <label
                      className="cht-block cht-text-xs !cht-font-bold cht-text-slate-300 cht-mb-1.5"
                      htmlFor="subject"
                    >
                      Subject *
                    </label>
                    <input
                      type="text"
                      className="cht-w-full cht-bg-white/10 cht-border cht-border-white/20 focus:cht-border-[#3e57da] focus:cht-bg-white/15 cht-rounded-xl cht-px-4 cht-py-3 cht-text-sm cht-text-white cht-placeholder-slate-400 focus:cht-ring-2 focus:cht-ring-[#3e57da]/50 cht-outline-none cht-transition-all"
                      id="subject"
                      placeholder="Project Scope / Consultation"
                      name="subject"
                      onChange={(e) => onChange(e)}
                      value={subject}
                      required
                    />
                  </div>
                </div>

                <div>
                  <label
                    className="cht-block cht-text-xs !cht-font-bold cht-text-slate-300 cht-mb-1.5"
                    htmlFor="message"
                  >
                    Brief Project Description / Message *
                  </label>
                  <textarea
                    className="cht-w-full cht-bg-white/10 cht-border cht-border-white/20 focus:cht-border-[#3e57da] focus:cht-bg-white/15 cht-rounded-xl cht-px-4 cht-py-3 cht-text-sm cht-text-white cht-placeholder-slate-400 focus:cht-ring-2 focus:cht-ring-[#3e57da]/50 cht-outline-none cht-transition-all"
                    id="message"
                    rows={4}
                    placeholder="Tell us about your requirements, timeline, or objectives..."
                    name="message"
                    onChange={(e) => onChange(e)}
                    value={message}
                    required
                  />
                </div>

                <div className="cht-pt-2">
                  <Button
                    type="submit"
                    variant="primary"
                    size="md"
                    fullWidth
                    isLoading={loading}
                    className="cht-py-3.5"
                  >
                    Submit Project Inquiry
                  </Button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      {show ? (
        <SuccessModal
          title="Form Submitted"
          message="Thank you for reaching out to us! We've received your message and will get back to you shortly. Your feedback is valuable to us, and we appreciate you taking the time to connect. Have a fantastic day!"
          errorMessage={formError}
          show={show}
          onClose={handleClose}
        />
      ) : null}
    </div>
  );
};

export default ContactForm;
